export default {
  namespaced: true,
  
  state: {
    currentStoreTransferId: null
  },
  
  getters: {
    getCurrentStoreTransferId: state => state.currentStoreTransferId
  },
  
  mutations: {
    setCurrentStoreTransferId(state, id) {
      state.currentStoreTransferId = id;
    },
    
    clearCurrentStoreTransferId(state) {
      state.currentStoreTransferId = null;
    }
  },
  
  actions: {
    saveStoreTransferId({ commit }, id) {
      commit('setCurrentStoreTransferId', id);
    },
    
    clearStoreTransferId({ commit }) {
      commit('clearCurrentStoreTransferId');
    }
  }
}
